// extracted by mini-css-extract-plugin
export default {"MSSpinnerContainer":"MSSpinner_MSSpinnerContainer__FDU-9"};